import React from "react";

import { cn } from "../cn";
import { SIDEBAR_LOGO_PATHS, SIDEBAR_LOGO_VIEWBOX, WORDMARK_PATHS, WORDMARK_VIEWBOX } from "./brand-logo-paths";

type BrandLogoProps = {
  className?: string;
  variant?: "default" | "sidebar" | "wordmark-light" | "brand-dark";
};

function LogoSvg({ viewBox, width, height, paths, fill, className }: { viewBox: string; width: number; height: number; paths: readonly string[]; fill: string; className?: string }) {
  return (
    <svg className={className} role="img" aria-label="3D Smile" width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      {paths.map((d, i) => (
        <path key={i} d={d} fill={fill} />
      ))}
    </svg>
  );
}

export function BrandLogo({ className, variant = "default" }: BrandLogoProps) {
  if (variant === "wordmark-light") {
    return <LogoSvg viewBox={WORDMARK_VIEWBOX} width={120} height={20} paths={WORDMARK_PATHS} fill="white" className={cn("tw-h-5 tw-w-[120px]", className)} />;
  }
  if (variant === "sidebar") {
    return <LogoSvg viewBox={SIDEBAR_LOGO_VIEWBOX} width={183} height={29} paths={SIDEBAR_LOGO_PATHS} fill="white" className={cn("tw-h-[29px] tw-w-[183px]", className)} />;
  }
  if (variant === "brand-dark") {
    return <LogoSvg viewBox={SIDEBAR_LOGO_VIEWBOX} width={210} height={34} paths={SIDEBAR_LOGO_PATHS} fill="#393631" className={cn("tw-h-[34px] tw-w-[210px]", className)} />;
  }
  return <LogoSvg viewBox={WORDMARK_VIEWBOX} width={150} height={25} paths={WORDMARK_PATHS} fill="#564F49" className={cn("tw-h-[25px] tw-w-[150px]", className)} />;
}
